// extracted by mini-css-extract-plugin
export default {"container":"container-qsAHI","headingWrapper":"headingWrapper-rMEPm","heading":"heading-wNBe0","success":"success-V7Tk9","error":"error-Z7t4B"};